/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Exportdate1Inputs */

const en__field_exportdate1 = /** @type {(inputs: _Field_Exportdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`export date`)
};

const de__field_exportdate1 = /** @type {(inputs: _Field_Exportdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Datum`)
};

/**
* | output |
* | --- |
* | "export date" |
*
* @param {_Field_Exportdate1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_exportdate1 = /** @type {((inputs?: _Field_Exportdate1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Exportdate1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_exportdate1(inputs)
	return de__field_exportdate1(inputs)
});
export { _field_exportdate1 as "_field_exportDate" }